export const en = {
  "save": "Save",
  "update": "Update",
  "accept": "Accept",
  "cancel": "Cancel",
  "close": "Close",
  "add": "Add",
  "check": "Check",
  "certificate": "Certificate",
  "certificates": "Certificates",
  "certification": "Certification",
  "certifications": "Certifications",
  "valid-certificate": "Valid certificate",
  "date": "Date",
  "valid-thru": "Valid thru",
  "dashboard": "Dashboard",
  "error": "Error Page",
  "forms": "Forms",
  "notifications": "Notifications",
  "my-profile": "My profile",
  "my-documents": "My Documents",
  "no-documents-available": "No documents available",
  "training-materials": "Training Materials",
  "open-in-webviewer": "Open in viewer",
  "expired": "Expired",
  "expired-training-materials": "Expired Training Materials",
  "register-headline": "Register",
  "register": "Register",
  "search": "Search",
  "print": "Print",
  "printed-via": "Printed via www.evalcard.com",
  "settings": {
    "label": "Settings",
    "publicProfile": {
      "showEmailInPublic": "Show email",
      "showPhoneInPublic": "Show phone",
      "showAddressInPublic": "Show address"
    }
  },
  "tables": "Tables",
  "tabs": "Tabs",
  "myeval": "EvalCard",
  "eval-id": "Eval-ID",
  "id": "ID",
  "timeline": "Timeline",
  "typography": "Typography",
  "admin": "Administrator",
  "user": "User",
  "templateAuthor": "Global Template Author",
  "users": "Users",
  "user-profile": "User Profile",
  "company-name": "Companyname",
  "company-logo": "Companylogo",
  "company-profile": "Companyprofile",
  "company-profile-admin": "Companyprofile",
  "company-invitation": "Companyinvitation",
  "invitation-sent": "Invitation sent",
  "new-password": "New password",
  "generate-new-password": "Generate new password",
  "current-password": "Current password",
  "repeat-password": "Repeat password",
  "password-successfully-changed": "Password successfully changed",
  "password-reset": "Password reset",
  "edit-user-profile": "Edit user profile",
  "edit-user-profile-admin": "Edit user profile",
  "system": "System",
  "widgets": "Widgets",
  "wizard": "Wizard",
  "logout": "Logout",
  "login": "Login",
  "companies": "Companies",
  "my-company": "My company",
  "leave-company": "Leave company",
  "delete-company": "Delete company",
  "company": "Company",
  "uid": "UID",
  "employees": "Employees",
  "employee": "Employee",
  "companyadmin": "Admin",
  "evalclient": "Evalclient",
  "coworker": "Employees",
  "coworker-profile": "Employee's Profile",
  "search-user": "Search user",
  "search-user-placeholder": "Name, email, EVAL-ID",
  "trainer": "Trainer",
  "training-level": "Training level",
  "gtp": "GTP",
  "authorityAdmin": "Admin",
  "trainerRO": "Trainer (Readonly)",
  "authorityAdminRO": "Admin (Readonly)",
  "protocols": "Test Reports",
  "report": "Test Report",
  "new-report": "New report",
  "all-reports": "All Test Reports",
  "all-assets": "All Assets",
  "report-from": "Report from",
  "report-details": "Report details",
  "data": "Data",
  "info": "Info",
  "attachment": "Attachment",
  "contact": "Contact",
  "continue": "Continue",
  "start": "Start",
  "summary": "Summary",
  "vin": "VIN",
  "licence-plate": "Licence plate",
  "owner": "Owner",
  "vehicles": "Vehicles",
  "vehicle": "Vehicle",
  "vehicle-details": "Vehicle details",
  "companyVehicle": "Vehicle",
  "valid": "Valid",
  "invalid": "Invalid",
  "tester": "Tester",
  "vehicles-admin": "Vehicles",
  "create-company-vehicle": "Create vehicle",
  "select-vehicle": "Select vehicle",
  "my-vehicles": "My vehicles",
  "my-vehicle": "My vehicle",
  "asset": "Asset",
  "assets": "Assets",
  "serial-number": "Serial number",
  "asset-type": "Asset type",
  "asset-types": "Asset types",
  "calibration-valid-thru": "Calibration valid thru",
  "requires-calibration": "Requires periodic calibration",
  "calibration-warning-days": "Warning period (days)",
  "gtp-classes": "GTP classes",
  "code": "Code",
  "subtype": "Subtype",
  "icon": "Icon",
  "qualification": "Qualification (HTML)",
  "gtpIcon": {
    "car": "Car",
    "forklift": "Forklift",
    "gauge": "Gauge",
    "train-front": "Train",
    "ship": "Ship",
    "plane": "Plane",
    "settings": "Gear",
    "wrench": "Wrench"
  },
  "photos": "Photos",
  "new-vehicle": "New vehicle",
  "manufacturer": "Manufacturer",
  "no-manufacturer": "(No Manufacturer)",
  "no-vehicle": "(No Vehicle)",
  "vehicle-manufacturer": "Vehicle manufacturer",
  "create-vehicle": "Create vehicle",
  "create-vehicle-manufacturer": "Create vehicle manufacturer",
  "construction-year": "Constructionyear",
  "change-password": "Change password",
  "roles": "Roles",
  "actions": "Actions",
  "action": "Action",
  "profile": "Profile",
  "email": "Email",
  "basic": "Basic",
  "special": "Special",
  "breakdown": "Breakdown",
  "click-for-details": "Click for details",
  "rights": "Rights",
  "details": "Details",
  "information": "Information",
  "details-and-information": "Details & Information",
  "name": "Name",
  "namename": "Description",
  "firstname": "Firstname",
  "lastname": "Lastname",
  "fullname": "Full name",
  "password": "Password",
  "street": "Street",
  "number": "Number",
  "city": "City",
  "country": "Country",
  "forgot-password": "Forgot password",
  "recover-password": "Recover password",
  "back": "Back",
  "back-to-login": "Back to login",
  "go-to-login": "Go to login",
  "choose-picture": "Choose picture",
  "choose-logo": "Choose logo",
  "image-format-not-supported": "This image format is not supported. Please choose a JPG or PNG image.",
  "send-invitation": "Send invitation",
  "zipcode": "Zipcode",
  "previous": "Previous",
  "abort": "Abort",
  "i-understand": "understand",
  "no": "No",
  "yes": "Yes",
  "inputs": "Inputs",
  "user-activated": "User activated",
  "user-not-activated": "user not activated",
  "user-did-not-receive-activation-email": "user did not receive activation email yet",
  "allow-coworkers-to-show-on-profile": "Allow employees to show on profile:",
  "resend-activation-email": "Resend activation email",
  "coworker-education-status": "Employee qualification status",
  "card": "Card",
  "certification-authority": "Certification authority",
  "certification-authority-admin": "Certification authority",
  "certification-authorities": "Certification authorities",
  "delete-certification-authority": "Delete certification authority",
  "certificate-templates": "Certificate templates",
  "certificate-template": "Certificate template",
  "creating-certificates": "Creating certificates...",
  "issue-certificate": "Issue certificate",
  "issue-date": "Issue date",
  "due-date": "Due date",
  "issued-on": "Issued on",
  "issued-by": "Issued by",
  "author": "Author",
  "certificate-name": "Certificate name",
  "mileage": "Mileage",
  "certificate-number": "Certificate number",
  "born-on": "born on",
  "public": "Public",
  "back-to-the-app": "Back to the app",
  "can-create-reports": "Create reports possible",
  "temporary-certification": "Temporary Certification",
  "temporary-days-valid": "Valid For (Days)",
  "valid-for": "Valid for(Years)",
  "pdf-template": "PDF-template",
  "pdf-certificate": "PDF-certificate",
  "show-pdf-certificate": "Show pdf-certificate",
  "standards": "Standards (HTML)",
  "text-block": "Text after Standards (HTML)",
  "text-block-hint": "Placeholders: {placeholders} — qualifikationen inserts the texts of the assigned GTP classes",
  "digital-signature": "Digital signature",
  "eval0": "HV-0",
  "eval1": "HV-1",
  "eval2": "HV-2",
  "eval3": "HV-3",
  "eval4": "HV-4",
  "evalc": "HV-C",
  "evalbex": "HV-BEX",
  "evall": "HV-L",
  "evalf": "HV-F",
  "evalpro": "HV-Pro",
  "evals": "HV-S",
  "evalt": "HV-T",
  "sonstige": "Other",
  "others": "Others",
  "levelGroupBase": "Basic Levels",
  "levelGroupSpecial": "Special - requires prior qualification",
  "levelGroupSpecialTraining": "Special Training without prerequisites",
  "level": "Level",
  "type": "Type",
  "training-data": "Training documents",
  "training-info": "Training information",
  "generated-password": "Generated password",
  "invitation-email": "Invitation Email",
  "document": "Document",
  "documents": "Documents",
  "active": "active",
  "inactive": "inactive",
  "all": "ALL",
  "all-sort": "All/Sort",
  "created-on": "Created on",
  "result": "Result",
  "results": "Results",
  "try-again": "Try again",
  "status": "Status",
  "published": "Published",
  "draft": "Draft",
  "sn": "SN",
  "something-went-wrong": "Something went wrong",
  "checking-prerequisites": "Checking prerequisites...",
  "prerequisite-warning-title": "Missing Prerequisites",
  "missing-prerequisites": "Requires at least:",
  "info-signs": "Signs",
  "danger": "Danger",
  "hazardous-voltage": "Hazardous Voltage",
  "no-access-1": "No Access",
  "no-access-2": "for unauthorized persons",
  "access-only-by": "Access only by",
  "company-logo-is-missing": "Companylogo is missing",
  "download": "Download",
  "access-denied": "Access denied",
  "dont-switch-on": "Don't switch on",
  "hv-system": "HV-System",
  "disconnected": "Disconnected",
  "disconnected-by": "Disconnected by",
  "works-in-progress": "Works in progress",
  "forum": "EV Forum",
  "title": "Title",
  "topic": "Topic",
  "topics": "Topics",
  "from": "from",
  "answers": "Answers",
  "post-answer": "Post answer",
  "edit-answer": "Edit answer",
  "created": "Created",
  "created-by": "Created by",
  "is-global": "Global template",
  "templateauthor-requires-report-permission": "Only users who can create reports can become a global template author.",
  "new-topic": "New topic",
  "edit-topic": "Edit topic",
  "create-new-topic": "Create new topic",
  "last-answer": "Last answer",
  "view-all": "View all",
  "attachments": "Attachments",
  "link-url": "Link (URL)",
  "newest-topics": "Newest topics",
  "privacy-policy": "Privacy Policy",
  "new-files": "New Files",
  "existing-files": "Existing Files",
  "courses": "Courses",
  "location": "Location",
  "loading": "Loading",
  "view-details": "View Details",
  "no-courses-found": "No courses found",
  "no-courses-assigned": "No courses available",
  "dialog": {
    "are-you-sure": "Are you sure?",
    "an-unexpected-error-occured": "An unexpected error occured. Try again later",
    "do-you-really-want-the-user-to": "Do you really want to delete the user",
    "do-you-really-want-the-invitation-to": "Do you really want to delete the invitation",
    "delete": "?",
    "delete-user": "Delete user",
    "delete-topic": "Delete topic",
    "delete-topic-answer": "Delete topic answer",
    "remove-user": "Remove user",
    "remove-trainer": "Remove trainer",
    "remove-from-company": "Remove from company",
    "remove-from-certification-authority": "Remove from certification authority",
    "create-user": "Create user",
    "the-most-important-information": "The most important information",
    "create-company": "Create company",
    "the-most-important-information-about-the-company": "The most important information about the company",
    "create-company-vehicle": "Create company vehicle",
    "the-most-important-information-about-the-vehicle": "The most important information about the vehicle",
    "the-most-important-information-about-the-asset": "The most important information about the asset",
    "create-report": "Create report",
    "where-is-the-company-located": "Where is the company located",
    "where-is-the-certification-authority-located": "Where is the certification authority located",
    "whats-the-role-of-the-person": "Whats the role of the person",
    "where-does-the-person-live": "Where does the person live",
    "further-details": "Further Details",
    "register-successfull": "Register successfull",
    "great-you-will-receive-an-email": "Great you will receive an email with a password recovery link",
    "this-should-not-take-longer-than": "This should not take longer than 5 minutes. Please also look in your spam folder",
    "i-agree": "I agree",
    "to": "to",
    "terms-and-conditions": "terms and conditions",
    "hereby-i-agree": "I agree that EvalCert GmbH can use my personal data for the purpose of issuing an Evalcard and for the user registration on my.evalcard.com",
    "further-i-agree-to": "Furthermore, I agree that EvalCert GmbH can inform me via e-mail newsletter about news in the high-voltage area (new training courses, new products or events) until further notice.",
    "allowed-to-be-used": " (.de / .com)",
    "refusal-is-allways": "A revocation is anytime possible via email to ",
    "possible": "possible",
    "the-e-val-card-is-the": "The EVAL – Card is the proof of qualification in checkcard-format. The shortcut EVAL stands for Electric Vehicle Access License",
    "complete-user-data": "Complete user data",
    "complete-user-data-info": "For proper support and to make use of all features, you need to have a complete user-profile",
    "your-password-reset-is-being-processed": "Your password reset is being processed. If this takes longer than a few minutes, try again",
    "your-password-has-been-sent": "Your password has been recovered successfully. You should receive an email with your new password within a few minutes.",
    "if-it-did-not-work": "Please also look in your spam folder. If it takes longer than a few minutes, try again.",
    "user-not-authorized": "Email or Password wrong",
    "user-not-activated": "This user is not activated. Use the link in the registration email",
    "user-or-password-wrong": "Email or Password wrong",
    "users-selected": "Users selected",
    "user-profile-update-successfull": "User-profile update successfull",
    "user-profile-update-failed": "User-profile update failed. Please try again later ",
    "do-you-really-want-to-leave-the-company": "Do you really want to leave the company?",
    "in-order-to-accept-a-company-invitation": "To accept a company invitation, you need to be registered and logged in",
    "do-you-really-want-to-join-the-company": "Do you really want to join the company?",
    "if-you-are-already-in-a-company-you-will-be-removed": "If you are already in a company you will be removed",
    "you-are-not-a-member-of-a-company": "You are not in a company. As soon as you are in a company, you can use this page",
    "you-are-not-a-member-of-a-certification-authority": "You are not a member of a certification authority",
    "do-you-really-want-the-company-to": "Do you really want to delete the company",
    "company-created-successfully": "Company created successfully",
    "company-already-exists": "company with this Name/Email already exists",
    "vehicle-save-successfully": "Vehicle saved successfully",
    "asset-save-successfully": "Asset saved successfully",
    "gtp-class-save-successfully": "GTP class saved successfully",
    "gtp-class-already-exists": "A GTP class with this code already exists",
    "do-you-really-want-the-gtp-class-to": "Do you really want to delete the GTP class",
    "asset-type-save-successfully": "Asset type saved successfully",
    "do-you-really-want-the-asset-type-to": "Do you really want to delete the asset type",
    "vehicle-already-exists": "Vehicle with this VIN and owner already exists",
    "vehicle-accepted": "Vehicle got merged into the system",
    "vehicle-manufacturer-accepted": "Vehiclemanufacturer got merged into the system",
    "report-save-successfully": "Report saved successfully",
    "report-already-exists": "Report already exists",
    "create-company-failed": "Create company failed. Please try again later",
    "save-user-success": "User saved successfully",
    "user-already-exists": "A User with that E-mail or Name already exists",
    "save-company-success": "Company saved successfully",
    "save-company-failed": "Saving company failed. Try again later",
    "save-changes-success": "Saved changes successfully",
    "do-you-really-want-the-vehicle-to": "Do you really want to delete the vehicle",
    "do-you-really-want-the-asset-to": "Do you really want to delete the asset",
    "do-you-really-want-the-report-to": "Do you really want to delete the report",
    "do-you-really-want-the-certificate-to": "Do you really want to delete the certificate",
    "do-you-really-want-the-vehicle-manufacturer-to": "Do you really want to delete the manufacturer",
    "save-vehicle-manufacturer-success": "Vehiclemanufacturer saved successfully",
    "save-vehicle-manufacturer-error": "Save vehiclemanufacturer failed. Try again later",
    "save-vehicle-success": "vehicle saved successfully",
    "save-vehicle-error": "Saveing vehicle failed",
    "who-works-in-the-company": "Who works in the company?",
    "who-works-in-the-certification-authority": "Who works in the certification authority?",
    "your-company-has-been-created-check-your-emails": "Your company has been created check your emails. Please also look in your spam folder",
    "if-you-havent-received-an-email-yet": "If you havent received an email yet. You can try to send it again here",
    "if-this-did-not-work": "If this did not work. You can try leaving the company and try again from scratch",
    "is-already-in-a-company": "is already in a company",
    "invite-user-already-exists-in-company": "User with that email already exists in company",
    "invite-user-already-exists-in-other-company": "User is already in another company",
    "create-certification-authority": "Create certification-authority",
    "certification-authority-save-successfully": "Certification-authority saved successfully",
    "certification-authority-already-exists": "certification-authority with this Email/Name already exists",
    "certificate-already-exists": "Certificate with this name already exists",
    "certificate-save-successfully": "Certificate saved successfully",
    "do-you-really-want-to-delete": "Do you really want to delete",
    "delete-report-template": "Delete checklist template",
    "create-certificate": "Create certificate",
    "create-certificate-template": "Create certificate-template",
    "who-gets-the-certificate": "Who receives the certificate",
    "user-with-this-eval-id-was-not-found": "User with this eval-id was not found",
    "you-can-only-add-reports-if-you-have-company-vehicles": "You can only add reports if you have company vehicles",
    "you-can-only-input-eu-numbers": "You can only input the eu number-format",
    "you-dont-have-the-rights": "You dont have the rights for this feature",
    "certificate-template-save-success": "Certificate-template saved successfully",
    "certificate-template-sort-save-success": "Certificate-template sorting saved successfully",
    "your-certification-authority-does-not-have-templates": "Create a template in your certification-authority first",
    "this-company-is-not-yet-activated": "This company is not yet activated. An email with the activation link should be sent",
    "welcome-to-the-dashboard": "Welcome to the dashboard! You are not yet in a company. You will see an overview of your reports here once you are in a company",
    "valid-certificates": "Valid certificates",
    "certificates-last-30-days": "Certificates - last 30 days",
    "certificates-on": "Certificates on",
    "reports-last-30-days": "Reports - last 30 days",
    "no-data-available": "No data available yet",
    "this-manufacturer-does-not-exist": "This manufacturer does not exist in the system yet. It will created for you",
    "this-vehicle-does-not-exist": "This vehicle does not exist yet. It will be created for you",
    "required-to-complete-registration": "To complete the registration this is required",
    "email-is-already-used": "This email is already used",
    "enter-valid-birthday-date": "Please enter a valid birthday",
    "enter-valid-eu-number-format": "Please enter only numbers in the EU-Number format",
    "only-use-numbers-with-or": "Please only use numbers and '-' or '/'",
    "this-user-is-already-in-this-certification-authority": "This user is already in this certification authority",
    "this-user-is-already-selected": "This user is already selected",
    "this-user-is-already-in-a-company": "This user is already in a company",
    "the-document-could-not-be-loaded": "The document could not be loaded",
    "": "",
    "continue": "Continue",
    "finish": "Finish",
    "cannot-add-users": "The following users were conflicting:",
    "add-course": "Add course",
    "course-created-successfully": "Course added successfully",
    "course-updated-successfully": "Course updated successfully",
    "mark-course-as-free": "Mark course as free",
    "scan-qr-code": "Scan QR-Code",
    "scan-to-join-course": "Scan QR-Code, to enroll in course",
    "remove-participant": "Remove Participant",
    "remove-participant-description": "Remove this participant from course?",
    "user-is-already-participant": "This user is already participant",
    "user-already-selected": "This user is already selected",
    "delete-course": "Delete course",
    "delete-course-description": "This course will be deleted. All participants will be removed. Continue?",
    "course-removed": "Course has been removed",
    "remove-efk-success": "ESP-Status removed from user",
    "create-checklist": "Create checklist",
    "make-efk-success": "ESP-Status successfully assigned, user has been notified",
    "resend-efk-success": "ESP invitation has been resent",
    "participants-added-successfully": "Participants added successfully",
    "delete-document": "Delete document",
    "delete-document-description": "Do you really want to delete this document",
    "delete-certificate-template": "Delete certificate template",
    "do-you-really-want-the-certificate-template-to": "Do you really want to delete the certificate template",
    'do-you-really-want-the-certification-authority-to': "Do you really want to delete the certification authority",
    "delete-task": "Delete Task",
    "do-you-really-want-to-delete-the-task": "Do you really want to delete the Task \"{name}\"",
    "delete-section": "Delete Section",
    "do-you-really-want-to-delete-the-section": "Do you really want to delete the Section \"{name}\"",
    "course-content-saved-successfully": "Course Content saved successfully",
    "remove-certification-authority": "Remove Certification Authority",
    "do-you-really-want-to-remove-certification-authority": "Do you really want to remove the certification authority \"{name}\"",
    "remove-course-content": "Remove Course Content",
    "do-you-really-want-to-remove-course-content": "Do you really want to remove the course content \"{name}\"",
    "successfully-removed-course-content": "Successfully removed course content",
    "language-already-exists-in-course": "The selected language already exists in this course",
    "do-you-really-want-to-remove-course": "Do you really want to remove the course \"{name}\"",
    "successfully-removed-course": "Successfully removed course",
    "publish-course-warning": "Are you sure you want to publish '{name}'? Once published, the course cannot be modified until unpublished.",
    "unpublish-course-confirmation": "Are you sure you want to unpublish '{name}'? This will allow modifications again.",
    "course-published-successfully": "Course published successfully",
    "course-unpublished-successfully": "Course unpublished successfully",
    "successfully-enrolled-course": "Successfully enrolled in course",
    "remove-enrollment": "Remove Enrollment",
    "do-you-really-want-to-remove-enrollment": "Do you really want to remove the enrollment",
    "successfully-removed-enrollment": "Successfully removed enrollment",
  },
  'academy-documents': 'Academy Documents',
  'completed-on': 'Completed on',
  'from-section': 'From section',
  'from-task': 'From task',
  'no-documents-in-course': 'No documents available in this course',
  'back-to-documents': 'Back to My Documents',
  'unknown-course': 'Unknown Course',
  'error-loading-documents': 'Error loading documents',
  tooltip: {
    'csv-export': 'CSV Export',
    'add-user': 'Add user',
    'invite-user': 'Invite user',
    'delete-user': 'Delete user',
    'remove-user': 'Remove user',
    'edit-user': 'Edit user',
    'view-user': 'View user',
    'send-invitation-again': 'Send invitation again',
    'send-activation-again': 'Send activation-link again',
    'admin-cant-leave-company': 'As eval-client you cant-leave the company',
    'leave-company': 'Leave company',
    'add-company': 'Add company',
    'edit-company': 'Edit company',
    'delete-company': 'Delete company',
    'add-selected-users-to-company': 'Add selected users to company',
    'add-selected-users-to-course': 'Add selected users to course',
    'add-vehicle': 'Add vehicle',
    'show-vehicle': 'Vehicle details',
    'edit-vehicle': 'Edit vehicle',
    'view-vehicle': 'View vehicle',
    'accept-vehicle': 'Accept vehicle',
    'accept-vehicle-manufacturer': 'Accept vehicle manufacturer',
    'delete-vehicle': 'Delete vehicle',
    'add-asset': 'Add asset',
    'add-gtp-class': 'Add GTP class',
    'edit-gtp-class': 'Edit GTP class',
    'delete-gtp-class': 'Delete GTP class',
    'add-asset-type': 'Add asset type',
    'edit-asset-type': 'Edit asset type',
    'delete-asset-type': 'Delete asset type',
    'show-asset': 'Asset details',
    'edit-asset': 'Edit asset',
    'delete-asset': 'Delete asset',
    'add-vehicle-manufacturer': 'Add vehicle manufacturer',
    'edit-vehicle-manufacturer': 'Edit vehicle manufacturer',
    'delete-vehicle-manufacturer': 'Delete vehicle-manufacturer',
    'vehicle-details-missing': 'Vehicle Details missing',
    'remove-invitation': 'Remove invitation',
    'send-missing-activations': 'Send missing activations',
    'show-password': 'Show password',
    'hide-password': 'Hide password',
    'create-report': 'Create report',
    'select-for-report': 'select for report',
    'add-question': 'Add question',
    'remove-question': 'Remove question',
    'create-certificates': 'Create certificates',
    'view-certificate': 'View certificate',
    'delete-certificate': 'Delete certificate',
    'view-report': 'View report',
    'delete-report': 'Delete report',
    'no-pdf-found': 'No pdf found',
    'add-report': 'Add-report',
    'add-certificate': 'Add certificate',
    'no-certificate-to-create-report': "You don't own a certificate to create reports",
    'add-certification-authority': 'Add certification-authority',
    'edit-certification-authority': 'Edit certification-authority',
    'delete-certification-authority': 'Delete certification-authority',
    'add-certificate-template': 'Add certificate-template',
    'edit-certificate-template': 'Edit certificate-template',
    'delete-certificate-template': 'Delete certificate-template',
    'add-report-template': 'Add report template',
    'edit-report-template': 'Edit report template',
    'delete-report-template': 'Delete report template',
    'view-certificate-training-data': 'View certificate training document',
    'save-sorting': 'Save sort',
    'mark-user': 'Mark user for csv-export',
    'open-topic': 'Open Topic',
    'edit-topic': 'Edit Topic',
    'delete-topic': 'Delete Topic',
    'edit-topic-answer': 'Edit Answer',
    'delete-topic-answer': 'Delete Answer',
    'select-all-users': 'Select all current users for csv-export',
    'add-course': 'Add course',
    'show-qr': 'Show QR-Code',
    'edit-course': 'Edit course',
    'publish-course': 'Publish course',
    'unpublish-course': 'Unpublish course',
    'remove-course': 'Delete course',
    'view-course': 'View Course',
    'remove-efk': 'Remove ESP',
    'see-more': 'See more',
  },
  phone: 'Phone',
  address: 'Address',
  birthday: 'Birthday',
  'profile-picture': 'Profile-picture',
  userprofile: {
    'edit-profile': 'Edit profile',
    'public-profile': 'Public profile',
    'following-information': 'Following information will be shown in the public profile',
    'notification-settings': 'If the company does not send notifications, this setting has no effect.',
  },
  "training-director": "Trainer",
  "participated-the-training": "participated the training ",
  "result-protocol": "Result protocol",
  "measurements": "Measurements",
  "freischaltung": "Disconnection",
  "isolationswiderstand": "Isolation resistance",
  "potentialausgleich": "Potential equalization",
  "r": {
    "measuring-instrument-functionality": "Measuring instrument functionality",
    "positive-test-done": "Positive-test done",
    "voltage-between-hv-plus-and-chassis": "Voltage between hv plus and chassis",
    "voltage-between-hv-plus-and-hv-minus": "Voltage between hv plus and hv minus",
    "voltage-between-hv-minus-and-chassis": "Voltage between hv minus and chassis",
    "the-tester-accepts-the-security-instructions": "The tester confirms compliance with the manufacturer's safety instructions",
    "measuring-instrument-tested-at-reference-source": "Measuring instrument tested at reference source",
    "measuring-instrument-tested": "Meter function checked?",
    "absence-of-voltage": "Absence of voltage",
    "absence-of-voltage-confirmed": "Absence of voltage confirmed",
    "voltage": "Voltage",
    "used-voltage": "Used voltage",
    "used-test-voltage": "Used test voltage",
    "isolation-resistance-between-hv-plus-and-chassis": "Isolation resistance between hv plus and chassis",
    "isolation-resistance-between-hv-minus-and-chassis": "Isolation resistance between hv minus and chassis",
    "isolation-standard": "Target isolation resistance",
    "resistance-per-volt": "Resistance per Volt",
    "hv-system-voltage": "HV-System voltage",
    "further-measurements-if-needed": "Further measurements if needed",
    "test-current": "Test current (A)",
    "test-current-q": "Test current...",
    "measuring-point": "Measuring point",
    "measuring-point-chassis-vs": "Measuring point chassis vs...",
    "converter-housing": "Converter housing",
    "further-voltage-measurements-if-needed": "Further voltage measurements if needed",
    "measurements-ok-if-smaller-than-1-v": "Measurements ok if smaller than 1V",
    "visual-inspection": "Visual inspection",
    "cable-visual-inspection": "Cable checked for visible damage?",
    "connector-visual-inspection": "Connector checked for visible damage?",
    "isolation-test": "Isolation test",
    "cable-isolation-test": "Cable insulation resistance checked?",
    "function-test": "Function test",
    "cable-function-test": "Charging process successfully tested?",
    "charging-cable-inspection-notes": "Additional checks if required",
  },
  'new-report-no-id': 'New report',
  'required-field': 'This field is mandatory',
  'fill-out-all-required-fields': 'Please fill out all mandatory fields!',
  'valid-email-only': 'Please fill in a valid mail address.',
  'max-characters': 'Max {count} characters',
  'certificate-notification': 'Certificate Notifications',
  'certificate-notification-company': 'This allows notifications to be deactivated for all employees.',
  'calibration-notification': 'Calibration Notifications',
  'calibration-notification-company': 'Reminder before the calibration of an object expires.',
  'haynes-pro-vehicle-details': 'HaynesPro Vehicle Details',
  'haynes-pro-no-details': 'There are no additional details for the selected vehicle.',
  'haynes-pro-hv-disconnect': 'High-voltage system: de-energising',
  'vehicle-details-admin': 'Vehicle Details',
  'haynes-pro-details': 'HaynesPro Details',
  'haynes-pro-details-admin': 'HaynesPro Details',
  'haynes-pro-details-not-found': 'Unfortunately, nothing was found for this vehicle.',
  'haynes-pro-load-error': 'The instructions could not be loaded.',
  retry: 'Try again',
  'haynes-pro-details-more-than-one-story': 'More than one manual has been found:',
  participants: 'Participants',
  'join-course': 'Join Course',
  'join-course-description': 'Really join course? The trainer can then manage you as a course participant.',
  'course-id-required': 'Course ID is required to join a course!',
  'course-not-found': 'Course has not been found',
  'error-loading-course': 'Error loading the course',
  'successfully-joined-course': 'Successfully joined course',
  'error-joining-course': 'Error joining the course, please contact your trainer.',
  refresh: 'Refresh',
  'edit-course': 'Edit Course',
  'make-efk': 'Order ESP',
  'make-efk-description': 'Order this user as an ESP. The user has to confirm it.',
  'resend-efk-invitation': 'Resend ESP invitation',
  'cancel-efk': 'Cancel ESP order',
  efk: 'ESP',
  'efk-position': 'ESP Position',
  'do-you-want-to-accept-efk-position': 'Do you want to accept the ESP position?',
  'do-you-want-to-refuse-efk-position': 'Do you want to refuse the ESP position?',
  refuse: 'Refuse',
  'in-order-to-handle-efk-position':
    'In order to handle the ESP position, you must either be logged in or register first.',
  'efk-position-accepted': 'ESP position accepted',
  'efk-position-refused': 'ESP position refused',
  pending: 'Pending',
  'remove-efk-description': 'Do you really want to remove ESP-Status from user?',
  'cancel-efk-description': 'Do you really want to cancel the ESP invitation for this user?',
  aborted: 'Aborted',
  checklists: 'Checklists',
  'all-checklists': 'All Checklists',
  manage: 'Manage',
  'global-templates': 'Global Templates',
  'global-template-authors': 'Global Template Authors',
  'add-global-template-author': 'Add global author',
  'remove-global-template-author-confirm': 'Really remove as global template author?',
  'report-templates': 'Report-Templates',
  'report-template': 'Report-Template',
  'create-report-template': 'Create Report-Template',
  'edit-report-template': 'Edit Report-Template',
  'delete-report-template': 'Delete Report-Template',
  checklist: 'Checklist',
  form: 'Form',
  'basic-information': 'Basic Information',
  'object-data': 'Object Data',
  'object-data-configuration': 'Object Data Configuration',
  'object-data-config-description': 'Configure custom fields to collect data when vehicle is not required',
  'requires-vehicle': 'Requires Vehicle',
  'assigned-vehicles': 'Assigned vehicles',
  'assigned-vehicles-hint': 'Empty = applies to all vehicles',
  'assigned-vehicles-no-data': 'Search for a vehicle …',
  'available-reports': 'Available reports',
  'create-report-now': 'Create report',
  'vehicle-added-to-fleet': 'Vehicle is now in your company vehicles',
  'requires-asset': 'Requires Asset',
  'select-asset': 'Select asset',
  'field-name': 'Field Name',
  'display-name': 'Display Name',
  'add-field': 'Add Field',
  'questions-description': 'Configure the questions for this template',
  'add-question': 'Add Question',
  'example-images': 'Example Images',
  'upload-example-images': 'Upload Example Images',
  'remove-image': 'Remove Image',
  'images-uploaded-successfully': 'Images uploaded successfully',
  'error-uploading-images': 'Error uploading images',
  'enable-validation': 'Enable Validation',
  'validation-configuration': 'Validation Configuration',
  'expected-value': 'Expected Value',
  'at-least-one-language-required': 'At least one language is required',
  'language-not-available': 'This language does not exist',
  'multilingual-fields-info':
    'Multilingual fields: Only enter the languages you have translations for. At least one language is required for names and questions.',
  operator: 'Operator',
  'validation-value': 'Validation Value',
  equal: 'Equal',
  'less-than': 'Less than',
  'greater-than': 'Greater than',
  'form-vehicle-info': 'This is a Form template. Forms are used when a vehicle is required for the report.',
  'checklist-object-data-info': 'This is a Checklist template. Checklists use object data configuration',
  'protocols-title': 'Protocols',
  'evalus-reports': 'Evalus Reports',
  'company-reports': 'Company Reports',
  'custom-templates': 'Custom Templates',
  description: 'Description',
  questions: 'Checkup Questions',
  question: 'Question',
  unit: 'Unit',
  boolean: 'Boolean',
  text: 'Text',
  // Own key: the generic `number` is DE "Nummer" (an ordinal), wrong sense for a data type.
  'question-type-number': 'Number',
  dropdown: 'Dropdown',
  options: 'Options',
  option: 'Option',
  'add-option': 'Add Option',
  'expected-option': 'Expected Option',
  'dropdown-options-required': 'Every dropdown question needs at least one filled option',
  'no-questions-yet': 'No questions yet — add the first one',
  'no-fields-yet': 'No fields yet — add the first one',
  'question-incomplete': 'This question is still incomplete',
  'is-active': 'Is Active',
  'add-checklist': 'Add Checklist',
  "select-checklist-template": "Select checklist template",
  "no-checklist-templates-available": "No checklist templates available.",
  "template": "Template",
  "checklist-object-data": "Checklist Object Data",
  "report-template-saved": "Report template has been successfully saved.",
  "new-checklist": "New Checklist",
  "view-checklist": "View Checklist",
  "checklist-from": "Checklist from",
  "checklist-details": "Checklist Details",
  "field": "Field",
  "checklist-created-successfully": "Checklist has been successfully created",
  "error-creating-checklist": "Error creating checklist. Please try again later.",
  "tested-with-object": "With the object",
  "required-asset-type": "Required object type",
  "required-asset-type-hint": "Object type this vehicle inspection has to be carried out with. Leave empty if no object is needed.",
  "can-calibrate": "Can calibrate objects",
  "calibratable-asset-type": "Calibratable object type",
  "calibratable-asset-type-hint": "Only objects of this type can be calibrated with this checklist.",
  "calibration-validity-months": "Calibration validity (months)",
  "calibration-validity-months-hint": "When this checklist is completed without errors, the object counts as calibrated again for that many months.",
  "select-required-asset": "Object used",
  "asset-locked-calibration-expired": "Locked – calibration expired more than {days} days ago ({date})",
  "asset-calibration-expired-on": "Calibration expired on {date}",
  "asset-restricted-hint": "This inspection may only be carried out with an object of type “{type}”.",
  "asset-none-of-required-type": "Your company has no object of type “{type}”. Create a matching object first to be able to run this inspection.",
  "asset-all-expired": "All matching objects have a calibration that expired more than {days} days ago and are therefore locked. Update the calibration date on the object to continue.",
  "asset-no-longer-allowed": "The selected object is no longer allowed for this inspection – its calibration may have been expired for too long in the meantime. Please check your selection.",
  "add-users-to-course": "Add users to course",
  "selected-users": "Selected users",
  "start-date": "Start Date",
  "end-date": "End Date",
  "evalus-reports-info": "Here you can find 'General Templates'. Specific reports can be found or created and managed in the 'Checklists' menu.",
  'role': 'Role',
  "eup": "EIP",
  "efk-tooltip": "Electrically Skilled Person ",
  "eup-tooltip": "Electrically Instructed Person",
  "efk-pending": "Invitation pending",
  "strictly-required": "Strictly Required",
  "strictly-required-info": "If enabled, the report cannot be submitted unless this validation passes",
  "validation-failed": "Mandatory validation failed",
  "cannot-submit-invalid-required": "Cannot submit: Required validation failed",
  "create-new-entry": "Create new entry",
  "trainer-invalid-certificate": "The trainer no longer has a valid HV-4 or HV-L certificate.",
  "to": "to",
  "date-filter": "Date filter",
  "clear-filter": "Clear filter",
  "oldest-first": "Oldest first",
  "newest-first": "Newest first",
  "course-documents": "Course Documents",
  "select-documents": "Select Documents",
  "upload-documents": "Upload Documents",
  "uploading": "Uploading",
  "drag-and-drop-files": "Drag and drop files here",
  "drop-files-here": "Drop files here",
  "or-click-to-browse": "or click to browse",
  "supported-formats": "Supported formats",
  "existing-documents": "Existing Documents",
  "documents-uploaded-successfully": "Documents uploaded successfully",
  "document-deleted-successfully": "Document deleted successfully",
  "no-course-documents-available": "You are not currently assigned to any course or no documents have been provided.",
  "more-files": "More files",
  "publicProfile": {
    "status": {
      "valid": "Valid",
      "expiringSoon": "Expiring soon",
      "expired": "Expired",
      "certified": "Certified",
      "open": "Open",
      "none": "None"
    },
    "jobTitle": {
      "efk": "HV-ESP",
      "hv0": "HV Instructed Person",
      "hv1-3": "HV-EIP",
    },
    "experienceStartDate": "Experience since",
    "backgroundImage": "Background image",
    "totalCertificatesTitle": "Certificates",
    "totalCertificatesDescription": "All completed certifications",
    "trainingLevelTitle": "Training Level",
    "trainingLevelDescription": "Highest training level.",
    "practicalOperationsTitle": "Practical Operations",
    "practicalOperationsDescription": "Practical experience with HV systems",
    "vehicleModelsTitle": "Vehicle Models",
    "vehicleModelsDescription": "Managed HV vehicle models",
    "dashboardTitle": "HV Experience Dashboard",
    "dashboardSubtitle": "Comprehensive Statistics & HV Expertise",
    "certificationsTitle": "Certifications",
    "certificationsSubtitle": "Overview of HV training and certifications",
    "instructor": "Instructor",
    "issuedOn": "Issued",
    "validUntil": "Valid until",
    "view": "View",
    "loadMoreCertificates": "Load more certificates",
    "hideCertificates": "Hide certificates",
    "nav": {
      "certifications": "Certifications",
      "specialTraining": "Special Training",
      "practicalExperiences": "Practical Experiences",
      "vehicleCategories": "Vehicle Categories"
    },
    "specialTraining": {
      "title1": "Special",
      "title2": "Training",
      "subtitle": "Additional qualifications and special certifications"
    },
    "practicalExperiences": {
      "title1": "Practical",
      "title2": "Experiences",
      "subtitle": "Practical experience with HV systems",
      "freischaltungen": {
        "title": "Disconnections",
        "description": "Performed disconnections on HV systems"
      },
      "isolationstests": {
        "title": "Insulation Measurements",
        "description": "Performed insulation resistance measurements"
      },
      "potentialtests": {
        "title": "Potential Equalization",
        "description": "Performed potential equalization measurements"
      },
      "checklists": {
        "title": "Checklists Completed",
        "description": "Completed safety checklists"
      },
      "chargingCableChecks": {
        "title": "Charging Cable Inspections",
        "description": "HV-C certified cable safety inspections"
      },
      "issuedCertificates": {
        "title": "Issued Certificates",
        "description": "Certifications issued as trainer"
      }
    },
    "vehicleCategories": {
      "title1": "Vehicle",
      "title2": "Categories",
      "subtitle": "Specialized in the following vehicle categories and applications"
    },
    "gtpCategories": {
      "roadVehicles": "Road Vehicles",
      "machines": "Machines",
      "racingVehicles": "Racing Vehicles",
      "aircraft": "Aircraft",
      "watercraft": "Watercraft",
      "railVehicles": "Rail Vehicles",
      "developmentProduction": "R&D",
      "aftersales": "Aftersales"
    },
    "footer": {
      "qrTitle": "QR Code Access",
      "qrSubtitle": "Scan code for quick profile access",
      "qrHint": "Scan with camera",
      "copyright": "© {year} Evalcard.com - All rights reserved",
      "imprint": "Imprint",
      "privacy": "Privacy Policy",
    },
    "shareProfile": "Share Profile",
    "currentEmployer": "Current Employer",
    "linkCopied": "Link successfully copied to clipboard",
    "evalusProfile": "Evalus Profile",
    "sharingNotSuccessful": "Sharing not successful.",
    "showInvalidCertificates": "Show expired certificates",
    "hideInvalidCertificates": "Hide expired certificates",
    "invalidCertificatesHint": "Hidden certificates that have been replaced by newer ones",
    "evalId": "Eval-ID",
    "ogCertifications": "Certifications",
    "ogDescription": "Public profile on EvalCard"
  },
  academy: {
    academy: 'Academy',
    administration: 'Administration',
    'my-orders': 'My Orders',
    'manage-courses': 'Manage courses',
    data: 'Base data',
    price: 'Price',
    'book-for-me': 'Book for me',
    'book-for-employee': 'Book for employees',
    passing_score: 'Passing score in %',
    max_exam_attempts: 'Maximum exam attempts',
    max_exam_attempts_hint: '0 = Unlimited',
    exam_attempts_remaining: 'Remaining attempts: {remaining} of {max}',
    exam_attempts_used: 'Attempts: {used}',
    exam_attempts_limit_reached: 'Maximum number of exam attempts reached',
    'edit-course': '@:edit-course',
    'all-languages-have-content': 'Course content already exists for all languages.',
    'must-be-company-member-to-book': 'You must be a member of a company to book courses.',
  },
  course: {
    course: 'Course',
    courses: 'Courses',
    'my-courses': 'My Courses',
    'my-courses-view': 'Course Overview',
    content: 'Course content',
    'edit-content': 'Edit Course Content',
    learn: 'Learn',
    'learn-trail': 'Learn trail',
    exam: 'Exam',
    'exam-trail': 'Exam trail',
    section: 'Section',
    addLearnSection: 'Add Learn Section',
    addLearnTask: 'Add Learn Task',
    addExamSection: 'Add Exam Section',
    addExamTask: 'Add Exam Question',
    sectionTitle: 'Section Title',
    taskTitle: 'Task Title',
    questionTitle: 'Question Title',
    enterSectionTitle: 'Enter section title...',
    enterTaskTitle: 'Enter task title...',
    enterQuestionTitle: 'Enter question title...',
    titleRequired: 'Title is required',
    titleTooShort: 'Title must be at least 2 characters',
    itemAddedSuccessfully: 'Item added successfully',
    errorAddingItem: 'Error adding item',
    selectItemFromSidebar: 'Select an item from the sidebar',
    task: 'Task',
    question: 'Question',
    enterTitle: 'Enter title...',
    addItem: 'Add Item',
    'purchase-course': 'Purchase Course',
    'purchase-initiated': 'Purchase initiated successfully',
    'learning-objectives': 'Learning Objectives',
    prerequisites: 'Prerequisites',
    syllabus: 'Course Syllabus',
    'learn-section': 'Learning Section',
    'exam-section': 'Examination Section',
    free: 'Free',
    booking: 'Booking',
    'purchase-date': 'Booked on',
    question_type: {
      question_type: 'Question Type',
      multiple_choice: 'Multiple Choice',
      number: 'Number',
      yes_no: 'Yes / No',
    },
    operator: {
      operator: 'Operator',
      equals: 'Equals',
      notEquals: 'Not Equals',
      greaterThan: 'Greater Than',
      lessThan: 'Less Than',
      greaterThanOrEqual: 'Greater Than Or Equal',
      lessThanOrEqual: 'Less Than Or Equal',
    },
    correct_answer: 'Correct Answer',
    yes: 'Yes',
    no: 'No',
    answer: 'Answer',
    unit: 'Unit',
    select_course: 'Select Course',
    select_language: 'Select Course Language',
    select_users: 'Select Users',
    error: {
      publish: 'Failed to publish course',
      course_content_required: 'At least one course content is required',
      certification_authority_required: 'At least one certification authority is required',
      certificate_template_missing: 'A certificate template must be selected for all certification authorities in each course content',
      learn_section_task_required: 'Every learning section must have at least one task',
      exam_section_task_required: 'Every exam section must have at least one question',
      monetization_required: 'The course must either be marked as free or have a Paddle product selected',
    },
    finish_course: 'Finish Course',
    completed_message: 'You have successfully completed this course.',
    linked_exam_section: 'Linked Exam Section',
    linked_exam_section_hint: 'After completing this learn section, this exam section will be presented',
    inline_exam_section: 'Exam Questions',
    inline_exam_section_info: 'Please answer all questions to continue. Your answers are final.',
    question_progress: 'Question {current} of {total}',
    complete_exam_section: 'Complete Section',
    answered_during_learning: 'Answered during learning',
    section_already_answered: 'This section has already been answered',
    answers_are_final: 'Answers cannot be changed',
  },
  enrollment: {
    status: {
      in_progress: 'Started',
      not_started: 'Not Started',
      completed: 'Completed',
    },
    enrolled_courses: 'Enrolled Courses',
    enroll_course: 'Enroll Course',
    enrolled_on: 'Enrolled on',
  },
  order: {
    order: 'Order | Orders',
    my_orders: 'My Orders',
    view_order: 'View',
    ordered_at: 'Ordered On',
    status: {
      paid: 'Paid',
      pending: 'Pending',
      failed: 'Failed',
      refunded: 'Refunded',
      cancelled: 'Cancelled',
    },
    payment: {
      paddle: 'Paddle',
      request: 'Request',
      none: 'None',
    },
    payment_method: 'Payment Method',
    purchased_by: 'Purchased By',
    purchased_for: 'Purchased for',
    product: 'Product',
    'page-title': 'Order',
    thank_you: 'Thank you for your purchase!',
    no_transaction_headline: 'Order not found',
    no_transaction_text: 'This order does not exist or an error occurred.',
    back_to_courses: 'Back to courses',
    go_to_my_courses: 'Go to my courses',
    purchase_now: 'Purchase now',
    payment_pending: 'Payment pending',
    payment_pending_text:
      'Your order has been received but the payment has not been completed yet. Please complete the payment to access your course.',
    cancel_success: 'Order cancelled successfully',
    cancel_error: 'Failed to cancel order',
  },

  language: 'Language',
  short_description: 'Short Description',
  progress: 'Progress',
  total: 'Total',
  complete_section: 'Complete Section',
  mark_task_complete: 'Mark Task as Complete',
  video_not_supported: 'Your browser does not support the video element.',
  overall_progress: 'Overall Progress',
  section_progress: 'Section Progress',
  task_completed: 'Task completed successfully',
  section_completed: 'Section completed successfully',
  error_completing_task: 'Error completing task',
  error_completing_section: 'Error completing section',
  next: 'Next',
  finish_learning: 'Finish Learning',
  start_learning: 'Start Learning',
  continue_learning: 'Continue Learning',
  take_exam_attempt: 'Take Exam Attempt',
  copy_course: 'Copy Course',
  select: 'Select',
  exam_results: {
    congratulations: 'Congratulations!',
    not_passed: 'Not Passed',
    score: 'Score',
    you_passed: 'You have successfully passed the exam!',
    need_score_to_pass: 'You need {score} to pass. Please try again.',
    score_details: 'Score Details',
    question: 'Question',
    back_to_course: 'Back to Course',
    retake_exam: 'Retake Exam',
    view_certificate: 'View Certificate',
    download_certificate: 'Download Certificate',
  },
  exam_export: {
    export_pdf: 'Export as PDF',
    title: 'Exam Result',
    participant: 'Participant',
    birthday: 'Date of birth',
    course: 'Course',
    attempt_number: 'Attempt',
    started_at: 'Started on',
    finished_at: 'Completed on',
    overall_score: 'Overall score',
    passed: 'Passed',
    failed: 'Not passed',
    given_answer: 'Given answer',
    correct_answer: 'Correct answer',
    no_answer: 'No answer',
    yes: 'Yes',
    no: 'No',
    select_attempt: 'Select attempt',
    no_attempts: 'No completed attempts available',
    no_exam: 'This course has no exam',
    generating: 'Generating PDF …',
    export_failed: 'Export failed',
  },
  'academy-assignment': {
    title: 'Assigned academy courses',
    'academy-course': 'Academy course',
    'available-for-regular-courses': 'Available for regular courses',
    'for-regular-courses-badge': 'For regular courses',
    'cannot-publish-regular-course': 'This course cannot be published because it is intended for regular courses',
    language: 'Language',
    'select-course-first': 'Select an academy course first',
    'no-matching-courses': 'No matching academy courses available (unpublished, enabled, matching level)',
    type: 'Type',
    'type-entry': 'Entry test',
    'type-intermediate': 'Intermediate test',
    'type-final': 'Final exam',
    assign: 'Assign academy course',
    remove: 'Remove assignment',
    'remove-warning': 'Removing the assignment deletes the participants’ enrollments and exam results for this academy course. Continue?',
    'assigned-successfully': 'Academy course assigned successfully',
    'removed-successfully': 'Assignment removed successfully',
    results: 'Participant results',
    participant: 'Participant',
    score: 'Score',
    status: 'Status',
    attempts: 'Attempt',
    passed: 'Passed',
    failed: 'Failed',
    'in-progress': 'In progress',
    'not-started': 'Not started',
  },
  exam_interface: {
    sections: 'Sections',
    overall_progress: 'Overall Progress',
    questions: 'questions',
    progress: 'Progress',
    section: 'Section',
    question_of: 'Question {current} of {total}',
    answered: 'Answered',
    not_answered: 'Not Answered',
    previous: 'Previous',
    next: 'Next',
    submit_exam: 'Submit Exam',
    quick_navigation: 'Quick Navigation',
    submit_exam_confirm: 'Submit Exam?',
    submit_exam_message: 'Are you sure you want to submit your exam?',
    answered_count: 'You have answered <strong>{answered}</strong> out of <strong>{total}</strong> questions.',
    cannot_change_warning: 'Once submitted, you cannot change your answers.',
    loading: 'Loading',
    error: 'Error',
    back: 'Back',
    select_certificate_authority: 'Select Certificate Authority',
    select_authority_message: 'Please select a certificate authority to issue your certificate.',
    no_authorities_available: 'No certificate authorities available for this course.',
    certificate_issued: 'Certificate issued successfully!',
    error_issuing_certificate: 'Error issuing certificate',
    exam_submitted_successfully: 'Exam submitted successfully!',
    exam_submit_error: 'Failed to submit exam',
  },
  could_not_add_section: 'Could not add section',
  successfully_added_section: 'Successfully added Section',
  could_not_add_task: 'Could not add task',
  successfully_added_task: 'Successfully added Task',
  could_not_remove_attachment: 'Could not remove attachment',
  successfully_removed_attachment: 'Successfully removed Attachment',
  could_not_remove_task: 'Could not remove task',
  successfully_removed_task: 'Successfully removed task',
  could_not_remove_section: 'Could not remove section',
  successfully_removed_section: 'Successfully removed section',
  "default-academy-issuer": "Default issuer for academy certificates",
  "default-academy-issuer-hint": "Automatically issues the certificates for completed academy courses, unless the participant already holds a certificate from another authority assigned to the course. Only one authority can be the default.",
  "my-documents-academy": "My Academy Documents",
}
